import { createFileRoute } from '@tanstack/react-router';

import { EditProfile } from '#modules/user/features/profile/components/EditProfile';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/profile'
)({
  component: EditProfile,
  ssr: false,
});
